import React, { Component } from "react";
import { Helmet } from "react-helmet";

export default class XXOO10 extends Component {
  componentDidMount() {
    this._ismounted = true;
    window.slider();
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  render() {
    return (
      <section id="xxoo10">
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Challenge your friends, family, and people around the world with a multiplayer game of XXOO 10 Tic Tac Toe.  Train your mind with over 300+ practice games.  You can play 3 in a row, 4 in a row, 5 in a row, ..up to connect 10 in a row.  Collect the most points and be the top player!"
          />
          <title>XXOO 10 - Multiplayer Tic Tac Toe</title>
        </Helmet>
        <a
            href="https://play.google.com/store/apps/details?id=com.doublethefun.xxoo10"
            target="_blank"
            rel="noopener noreferrer"
          >
        <img
          src="/images/xxoo10/banner.png"
          alt="XXOO 10 - Multiplayer Tic Tac Toe, play with all your friends"
          height="100%"
          width="100%"
        /></a>
        <div className="paragraph col-md-12">
          <h1>XXOO 10 - Multiplayer Tic Tac Toe</h1>
          Challenge your friends, family, and people around the world with a
          multiplayer game of{" "}
          <a
            href="https://play.google.com/store/apps/details?id=com.doublethefun.xxoo10"
            target="_blank"
            rel="noopener noreferrer"
          >
            XXOO 10
          </a>{" "}
          Tic Tac Toe. Train your mind with over 300+ practice games. You can
          play 3 in a row, 4 in a row, 5 in a row, ..up to connect 10 in a row.
          Collect the most points and be the top player!
          <br />
        </div>
        <div className="paragraph col-md-12">
          <h2 className="heading">HOW TO PLAY</h2>
          <a
            href="https://play.google.com/store/apps/details?id=com.doublethefun.xxoo10"
            target="_blank"
            rel="noopener noreferrer"
          >
            XXOO 10
          </a>{" "}
          is a take on the classic Tic Tac Toe XOXO multiplayer logic game, but
          can be played by up to 10 players and up to 10 across to win. Each
          player is given only one minute to make a move. The player who makes X
          number in a row horizontally, vertically, or diagonally wins the game
          and collects the points. Become the top player by collection the most
          points!{" "}
          <span role="img" aria-label="trophy">
            &#x1F3C6;
          </span>
          <br />
        </div>
        <div className="paragraph col-md-12">
          <h2 className="heading">FEATURES</h2>
          <ul>
            <li>300+ Practice Games! How many can you win?</li>
            <li>Up to 10 players at a time!</li>
            <li>Play 3 in a row, 4 in a row, ..up to 10 in a row!</li>
            <li>Connect anywhere with Friends &amp; Family</li>
            <li>Create and customize your own game</li>
            <li>Make friends and send messages while playing</li>
            <li>See who's online</li>
            <li>Collect the most point and be the champion!</li>
          </ul>
        </div>
        <div className="paragraph col-md-12">
          This game is suitable for all ages. We try our best to make it fun and
          enjoyable for everyone.
        </div>
        <div className="paragraph col-md-12">
          <h2 className="heading">Supported Languages</h2>
          <ul>
            <li>
              English - Tick Tat Toe, Noughts and Crosses, Naughts and Crosses
            </li>
            <li>Chinese (普通话) - 井字遊戲, Jǐng zì yóuxì</li>
            <li>
              Hindi (हिंदी) - शून्य काटा, Zero Kata, Kaat Koot, Katam Kataa,
              Phool aur Chaukadi
            </li>
            <li>
              German (Deutsche) - Drei Gewinnt, XXO, Kreis und Kreuz,
              Dodelschach
            </li>
            <li>Spanish (Español) - Tres En Raya (Three in a row)</li>
            <li>French (Français) - Morpion</li>
            <li>
              Japanese (日本語) - ○×ゲーム, ￮ × Gēmu, Maru Batsu (circle
              strike), Sanmoku Narabe
            </li>
            <li>Korean (한국어) - 박하 사탕 발가락</li>
            <li>
              Portuguese (Português) - Jogo Da Velha (game of the old lady)
            </li>
          </ul>
        </div>
      </section>
    );
  }
}
